function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { MANIFEST_PREFETCHED_ASSET_KEYS, PLATFORM_CDN_URL, PLATFORM_MANIFEST_ASSETS_CDN_DOMAIN, PREFETCH_TYPES } from "constants/prefetch-constants";
import * as Sentry from "@sentry/nextjs";
import { getPlatformManifest } from "./api-service";
export function getSignupDynamicAssetsLinks() {
    return _getSignupDynamicAssetsLinks.apply(this, arguments);
}
function _getSignupDynamicAssetsLinks() {
    _getSignupDynamicAssetsLinks = _async_to_generator(function*() {
        const platformManifestUrl = PLATFORM_CDN_URL;
        const signupDynamicAssetsLinks = [];
        try {
            const platformManifestResponse = yield getPlatformManifest();
            if (platformManifestResponse.response) {
                const platformManifest = platformManifestResponse.response;
                // manifest dependant assets
                MANIFEST_PREFETCHED_ASSET_KEYS.forEach((key)=>{
                    if (platformManifest[key]) {
                        signupDynamicAssetsLinks.push({
                            type: PREFETCH_TYPES.PREFETCH,
                            href: platformManifest[key].replace(PLATFORM_MANIFEST_ASSETS_CDN_DOMAIN, platformManifestUrl)
                        });
                    }
                });
            } else {
                Sentry.captureMessage(`getPlatformManifest() failed. Platform manifest response: ${JSON.stringify(platformManifestResponse)}`);
            }
        } catch (e) {
            Sentry.captureException(e);
        }
        return signupDynamicAssetsLinks;
    });
    return _getSignupDynamicAssetsLinks.apply(this, arguments);
}
